import React from 'react';

import { LockIcon } from '~/assets/icons';

import styles from './ProductInquireSummary.module.css';

const HIDDEN_TEXT = '비밀글입니다.';
type Props = {
  done?: boolean;
  name?: string;
  inquireAt?: string;
  title?: string;
  category?: string;
  secret?: boolean;
  hidden?: boolean;
};
function ProductInquireSummary({
  done,
  name,
  title,
  category,
  secret,
  hidden,
  inquireAt,
}: Props) {
  return (
    <div className={styles.wrapper}>
      <span className={styles.description}>{category}</span>

      <div className={styles.titleWrapper}>
        <h3 className={styles.title}>{hidden ? HIDDEN_TEXT : title}</h3>
        {secret && (
          <span className={styles.icon}>
            <LockIcon />
          </span>
        )}
      </div>

      <div className={styles.footer}>
        {done ? (
          <span className={styles.done}>답변완료</span>
        ) : (
          <span>답변대기</span>
        )}

        <span>{name}</span>
        <span>{inquireAt}</span>
      </div>
    </div>
  );
}

export default ProductInquireSummary;
